import { Component } from '@angular/core';

@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss'],
  standalone: false,
})
export class DemoComponent {
  title = 'Macmillan Learning Components Demo';
  angularVersion = '20';
}
